import { render, staticRenderFns } from "./SelectBase.vue?vue&type=template&id=e1b2f510&"
import script from "./SelectBase.vue?vue&type=script&lang=js&"
export * from "./SelectBase.vue?vue&type=script&lang=js&"
import style0 from "./SelectBase.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports